import { ArrayQ } from "@pdfking/structs"

import type { Margins, Point } from "#public"

/**
 * Margins turned over on an axis: on `x` left and right change places, on `y`
 * top and bottom. Several axes are turned over one after the other, so
 * `["x", "y"]` is the full symmetry.
 */
export const FlipMargins = <T>(
  margins: Margins<T>,
  axis: keyof Point<unknown> | (keyof Point<unknown>)[]
): Margins<T> =>
  (ArrayQ(axis) ? axis : [axis]).reduce<Margins<T>>(
    (flipped, along) => ({
      top: along === "y" ? flipped.bottom : flipped.top,
      right: along === "x" ? flipped.left : flipped.right,
      bottom: along === "y" ? flipped.top : flipped.bottom,
      left: along === "x" ? flipped.right : flipped.left,
    }),
    margins
  )
